module.exports = __webpack_public_path__ + "static/media/Shed.svg";